module.exports = __webpack_public_path__ + "static/media/RightIcon.6684e702.svg";